export default __webpack_public_path__ + "static/media/thirdfoundation.65b266b2.png";